// extracted by mini-css-extract-plugin
export default {"divContact":"Contact_divContact__902OT","locationContainer":"Contact_locationContainer__WZOt1"};